export function getSupabaseUrl() {
  return import.meta.env.VITE_SUPABASE_URL ?? import.meta.env.REACT_APP_SUPABASE_URL ?? "";
}

export function getSupabaseAnonKey() {
  return import.meta.env.VITE_SUPABASE_ANON_KEY ?? import.meta.env.REACT_APP_SUPABASE_ANON_KEY ?? "";
}

export function getSupabaseBucket() {
  return (
    import.meta.env.VITE_SUPABASE_BUCKET ??
    import.meta.env.REACT_APP_SUPABASE_BUCKET ??
    "blog-images"
  );
}

export function hasSupabaseEnv() {
  return Boolean(getSupabaseUrl() && getSupabaseAnonKey());
}
